import GoogleBusinessProfileLogoLargeSvg from '/src/com/yext/listingslaunchstorm/public/icons/google-business-profile-logo-large.svg';

/**
 * Creates a layout header prop for use in Taskflow component.
 * @param {string} pageTitle
 * @param {(React.ReactElement|string|undefined)} description
 * @param {Object|undefined} resourceLink
 * @return {Object}
 */
export const getLayoutHeaderProps = (pageTitle, description='', resourceLink=undefined) => {
  return {
    icon: <GoogleBusinessProfileLogoLargeSvg />,
    title: pageTitle,
    description: description,
    resourceLink: resourceLink,
  };
};
